// import { pages } from "../views/pages/admin/data";

export const menuItems = [
    {
        id: 1,
        label: 'menuitems.pcn-home.text',
        // icon: 'ri-pie-chart-2-line',
        icon: 'home.svg',
        link: '/home',
        forUser: true,
    },
    // {
    //     id: 2,
    //     label: 'menuitems.dashboard.text',
    //     // icon: 'ri-pie-chart-2-line',
    //     icon: 'dashboard.svg',
    //     link: '/dashboard',
    //     forUser: true,
    // },
    {
        id: 3,
        label: 'menuitems.pages.text',
        // icon: 'ri-file-3-line',
        icon: 'practice.svg',
        link: '/pages',
        forUser: true,
    },
    // {
    //     id: 3,
    //     label: 'menuitems.forms.text',
    //     // icon: 'ri-survey-line',
    //     icon: 'pages.svg',
    //     link: '/forms',
    //     forUser: true,
    // },
    {
        id: 4,
        label: 'menuitems.network.text',
        // icon: 'ri-line-chart-line',
        icon: 'network.svg',
        link: '/network',
        forUser: true,
    },
    {
        id: 41,
        label: 'menuitems.icb.text',
        // icon: 'ri-line-chart-line',
        icon: 'icb.svg',
        link: '/icb',
        forUser: true,
    },
    {
        id: 5,
        label: 'menuitems.training.text',
        // icon: 'ri-line-chart-line',
        icon: 'training.svg',
        link: '/training',
        forUser: true,
    },
    {
        id: 6,
        label: 'menuitems.support.text',
        // icon: 'ri-line-chart-line',
        icon: 'support-icon.svg',
        link: '/support',
        forUser: true,
    },
    {
        id: 7,
        label: 'menuitems.analytics.text',
        // icon: 'ri-line-chart-line',
        icon: 'analytics.svg',
        link: '/analytics',
        forUser: true,
    },
    {
        id: 8,
        label: 'menuitems.other.text',
        // icon: 'ri-file-3-line',
        icon: 'settings.svg',
        link: '/settings',
        forUser: true,
    },
    // {
    //     id: 20,
    //     label: 'menuitems.other.text',
    //     // icon: 'ri-account-circle-line',
    //     icon: 'settings.svg',
    //     forUser: false,
    //     subItems: [
    //         {
    //             id: 21,
    //             label: 'menuitems.other.list.users',
    //             link: '/users',
    //             forUser: false,
    //         },
    //         {
    //             id: 22,
    //             label: 'menuitems.other.list.practices',
    //             link: '/practices',
    //             forUser: false,
    //         },
    //         // {
    //         //     id: 23,
    //         //     label: 'menuitems.other.list.formBuilder',
    //         //     link: '/form-builder',
    //         //     forUser: false,
    //         // }
    //     ]
    // },
    // {
    //     id: 30,
    //     label: 'menuitems.admin.text',
    //     // icon: 'ri-account-circle-line',
    //     icon: 'dashboard.svg',
    //     forUser: false,
    //     subItems: pages,
    // },
]